let products_on_page = $(".products-on-page");
let next_url = products_on_page.data("next-url");
function loadMoreProducts(){
  $.ajax(
    {
        url: next_url,
        type:'GET',
        dataType:'html'
    }
  ).done(function(next_page){
        let new_products = $(next_page).find('.products-on-page');
    let new_url = new_products.data('next-url');
    // console.log(new_url);
    next_url = new_url;
    // console.log(next_url);
    if(next_url){
     products_on_page.append(new_products.html()); 
      bg_image_change();
    }
    
    
  });
    
}
function bg_image_change() {
  const product_blocks = document.querySelectorAll(".rimage-background");
  //console.log(product_blocks);
  product_blocks.forEach(function(prod_block){
    let sec_img_url = prod_block.dataset.lazyBgsetSrc;
    prod_block.style.backgroundImage = `url(${sec_img_url})`;
    prod_block.style.opacity = 1;
    prod_block.parentNode.setAttribute( 'style', 'display: block !important' );
  });
}


